(function () {
  var d = document;

  // Mobile nav
  var btn = d.querySelector('[data-nav-toggle]');
  var drawer = d.querySelector('[data-nav-drawer]');
  function setNav(open) {
    drawer.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    d.body.classList.toggle('nav-open', open);
  }
  if (btn && drawer) {
    btn.addEventListener('click', function () { setNav(!drawer.classList.contains('is-open')); });
    drawer.addEventListener('click', function (e) { if (e.target.closest('a')) setNav(false); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') setNav(false); });
    window.matchMedia('(min-width: 990px)').addEventListener('change', function () { setNav(false); });
  }

  // Collection sort
  d.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  });

  // Cart quantity auto-submit
  d.querySelectorAll('[data-cart-qty]').forEach(function (i) {
    i.addEventListener('change', function () { i.form.submit(); });
  });

  // Quantity +/- buttons
  d.querySelectorAll('[data-qty-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = b.parentElement.querySelector('input');
      var v = parseInt(input.value, 10) || 1;
      v = Math.max(1, v + parseInt(b.getAttribute('data-qty-step'), 10));
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // Product variants
  d.querySelectorAll('[data-product]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var form = root.querySelector('form');
    var idInput = form.querySelector('[name="id"]');
    var fieldsets = form.querySelectorAll('[data-option-index]');
    var priceEl = root.querySelector('[data-price]');
    var wasEl = root.querySelector('[data-compare]');
    var addBtn = form.querySelector('[data-add]');
    var gallery = root.querySelector('[data-gallery]');
    var currency = root.getAttribute('data-currency') || 'USD';
    var addLabel = addBtn.getAttribute('data-label-add');
    var soldLabel = addBtn.getAttribute('data-label-sold');
    var unavailLabel = addBtn.getAttribute('data-label-unavailable');

    function money(cents) {
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2); }
    }
    function selected() {
      return Array.prototype.map.call(fieldsets, function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function update() {
      var sel = selected();
      fieldsets.forEach(function (fs, i) {
        var s = fs.querySelector('[data-selected]');
        if (s) s.textContent = sel[i] || '';
      });
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return o === sel[i]; });
      });
      if (!v) {
        addBtn.disabled = true;
        addBtn.textContent = unavailLabel;
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (wasEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) { wasEl.textContent = money(v.compare_at_price); wasEl.hidden = false; }
        else { wasEl.hidden = true; }
      }
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? addLabel : soldLabel;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      var mid = v.featured_media && v.featured_media.id;
      if (gallery && mid) {
        var target = gallery.querySelector('[data-media-id="' + mid + '"]');
        if (target && getComputedStyle(gallery).overflowX === 'auto') {
          gallery.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        }
      }
    }
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]')) update();
    });
    update();
  });

  // YouTube: load the player only when clicked (fast page, no tracking until play)
  d.querySelectorAll('[data-yt]').forEach(function (card) {
    function play() {
      var id = card.getAttribute('data-yt');
      if (!id || card.classList.contains('is-playing')) return;
      var f = d.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      f.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
      f.allowFullscreen = true;
      f.title = card.getAttribute('aria-label') || 'Video';
      card.classList.add('is-playing');
      card.removeAttribute('tabindex');
      card.appendChild(f);
    }
    card.addEventListener('click', play);
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); play(); }
    });
  });
})();
